// Reglas de idioma sin dependencias de red (se usan en el Worker y en los tests).

// Palabras muy frecuentes en español y raras en inglés
const ES_WORDS = new Set([
  "el", "la", "los", "las", "un", "una", "es", "son", "de", "del", "que", "para", "por",
  "con", "sin", "y", "o", "en", "al", "se", "lo", "su", "sus", "como", "más", "mas",
  "realmente", "verdad", "mito", "bueno", "buena", "malo", "mala", "sirve", "ayuda",
  "tomar", "comer", "beber", "hace", "puede", "tiene", "salud",
]);

export function looksSpanish(text: string): boolean {
  const lower = text.toLowerCase();
  if (/[¿¡ñáéíóú]/.test(lower)) return true;
  const words = lower.match(/[a-záéíóúüñ]+/g) ?? [];
  if (!words.length) return false;
  const hits = words.filter((w) => ES_WORDS.has(w)).length;
  return hits >= 2 || hits / words.length >= 0.3;
}

// Expresiones coloquiales que el traductor automático traduce mal
// ("tensión" -> "tension" en vez de "blood pressure"; "engorda" -> "fattening")
const ES_FIXES: [RegExp, string][] = [
  [/\btensi[oó]n( arterial)?(?![\p{L}\p{N}_])/giu, "presión arterial"],
  [/\bengordar\b/gi, "ganar peso"],
  [/\bengorda\b/gi, "hace ganar peso"],
  [/\bengordan\b/gi, "hacen ganar peso"],
  [/\badelgazar\b/gi, "perder peso"],
  [/\badelgaza\b/gi, "hace perder peso"],
  [/\badelgazan\b/gi, "hacen perder peso"],
];

// Términos que, si están en la pregunta (ya normalizada), deben aparecer en la traducción. MyMemory
// devuelve a veces una entrada humana de su memoria que no encaja ("reduce tension")
const MUST_TRANSLATE: [RegExp, RegExp][] = [
  [/presi[oó]n arterial/i, /blood pressure/i],
  [/ganar peso/i, /weight|fat|obes/i],
  [/perder peso/i, /weight|slim|fat/i],
];

/** La traducción conserva los conceptos que sabemos que suelen perderse. */
export function translationKeepsTerms(spanish: string, english: string): boolean {
  const es = normalizeSpanish(spanish);
  return MUST_TRANSLATE.every(([term, en]) => !term.test(es) || en.test(english));
}

export function normalizeSpanish(text: string): string {
  return ES_FIXES.reduce((t, [pattern, repl]) => t.replace(pattern, repl), text);
}

/** MyMemory a veces deja alguna tilde de la palabra original; en inglés sobran. */
export function toAscii(text: string): string {
  const ascii = text.normalize("NFKD").replace(/[^\x00-\x7F]/g, "");
  return ascii || text;
}
